import { isFocusable } from "./isFocusable.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const tryToFocus = (element: HTMLElement): boolean => {
  if (isFocusable(element)) {
    element.focus();
    return true;
  }
  return false;
};
